import { OnboardingStep } from './data/OnboardingDTO';

const ONBOARDING_AUTO_OPEN_STEPS = [
  'welcome_to_ctms',
  'question_how_can_ctms_make_your_job_easier',
  'question_what_brings_you_to_ctms',
  'question_experience_with_ctms',
  'team_invitation',
  'install_chrome_extension',
  'getting_started_guide',
] as const;

export function getLastPendingStepName(steps: OnboardingStep['steps']) {
  for (const step of ONBOARDING_AUTO_OPEN_STEPS) {
    if (steps?.[step]?.status === 'pending') {
      return step;
    }
  }
  return null;
}
